import type {SavedViewVisibility} from './types'
import {DEFAULT_VIEWS_SORT, isViewsSortValue, type ViewsSortValue} from './views-sort-options'

export const VIEWS_SORT_PARAM = 'sort'

export const SECTION_SORT_PARAMS: Record<SavedViewVisibility, string> = {
  personal: 'personal_sort',
  team: 'team_sort',
}

function legacySort(params: URLSearchParams): ViewsSortValue {
  const value = params.get(VIEWS_SORT_PARAM)
  return isViewsSortValue(value) ? value : DEFAULT_VIEWS_SORT
}

export function resolveSectionSort(params: URLSearchParams, visibility: SavedViewVisibility): ViewsSortValue {
  const value = params.get(SECTION_SORT_PARAMS[visibility])
  return isViewsSortValue(value) ? value : legacySort(params)
}

export function applySectionSort(
  params: URLSearchParams,
  visibility: SavedViewVisibility,
  sort: ViewsSortValue,
): URLSearchParams {
  const next = new URLSearchParams(params)
  const key = SECTION_SORT_PARAMS[visibility]

  if (sort === legacySort(params)) {
    next.delete(key)
  } else {
    next.set(key, sort)
  }

  return next
}
